export const TypographyItem = ({
  title,
  fontFamily,
  fontWeight,
  fontSize,
  lineHeight,
  letterSpacing,
  example,
}: {
  title: string
  fontFamily: string
  fontWeight?: string
  fontSize: string | number
  lineHeight: string | number
  letterSpacing: string
  example: React.ReactNode
}) => {
  return (
    <div className="rounded-lg border border-p400-light bg-p400 p-4">
      <div className="text-lg font-semibold text-t100">{title}</div>
      <div>{example}</div>
      <div className="grid grid-cols-2 gap-8 md:flex">
        <FontThing name={"Font Family"} value={fontFamily} />
        {fontWeight ? <FontThing name={"Font Weight"} value={fontWeight} /> : null}
        <FontThing name={"Font Size"} value={fontSize} />
        <FontThing name={"Line Height"} value={lineHeight} />
        <FontThing name={"Letter Spacing"} value={letterSpacing} />
      </div>
    </div>
  )
}

const FontThing = ({ name, value }: { name: string; value: string | number }) => {
  return (
    <div className="space-x-1 font-sans text-t100">
      <span className="font-extralight">{name}:</span>
      <span className="font-bold">{typeof value === "number" ? `${value}px` : value}</span>
    </div>
  )
}
